var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRetake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2599_4128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 1.66663L11.6667 4.16663M11.6667 4.16663L9.16675 6.66663M11.6667 4.16663H5.66675C4.26662 4.16663 3.56655 4.16663 3.03177 4.43911C2.56137 4.67879 2.17892 5.06124 1.93923 5.53165C1.66675 6.06643 1.66675 6.76649 1.66675 8.16663V12.9166C1.66675 13.3036 1.66675 13.4972 1.68814 13.6596C1.83583 14.7814 2.7186 15.6642 3.84043 15.8119C4.00289 15.8333 4.1964 15.8333 4.58341 15.8333M8.33342 15.8333H14.3334C15.7335 15.8333 16.4336 15.8333 16.9684 15.5608C17.4388 15.3211 17.8212 14.9387 18.0609 14.4683C18.3334 13.9335 18.3334 13.2334 18.3334 11.8333V7.08329C18.3334 6.69628 18.3334 6.50277 18.312 6.34031C18.1643 5.21848 17.2816 4.33571 16.1597 4.18801C15.9973 4.16663 15.8038 4.16663 15.4167 4.16663M8.33342 15.8333L10.8334 18.3333M8.33342 15.8333L10.8334 13.3333",
    stroke: "#5466F9",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2599_4128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetake);
export default __webpack_public_path__ + "static/media/retake.f20da1b5.svg";
export { ForwardRef as ReactComponent };